import { useEffect, useState } from 'react';

export const useScreenSize = () => {
  const [screenWidth, setScreenWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    // Set initial width in case component mounts after resize
    setScreenWidth(window.innerWidth);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenWidth;
};
